<template>
  <div class="kairos">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="true" @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>
    <div v-if="section != null && sections.includes(section)">
      <!-- Main Section-->
      <div v-if="section == 'synchronization' && sections.includes('synchronization')" class="p-2" style="margin-top: 92px;">
        <Synchronization :key="compkeys.synchronization"></Synchronization>
      </div>
    </div>
    
  </div>
</template>

<script>
// Import the component with the line below.
import HeaderBar3 from '@/components/HeaderBar3.vue'
import Synchronization from '@/components/apps-components/kairos/Synchronization.vue'

import axios from "axios";

export default {
  name: 'Kairos',
  components: {
    HeaderBar3,
    Synchronization
  },
  data(){
    return {
      site: null,
      service_mode: null, // PV | PB
      stage: null,        // D  | P
      customer: null,     // Solve
      loading: false,
      // View
      view: 'kairos',
      hbref: 'hb_kairos',
      section: null,
      preferred: 'synchronization',
      sections: [],
      apps: {},
      // Keys
      compkeys: {
        synchronization: 0
      }
    }
  },
  methods:{
    solve(){
      this.loading = true
      const params = {view: this.view}
      const dest = this.site + '/suite/main/dnsuite'
      axios
          .get(dest, {params})
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps     = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
    },
    setSection_out(entry){
      this.section = entry
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    this.service_mode = process.env.VUE_APP_SERVICE_MODE
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.solve()
  }
}
</script>

<style scoped>

</style>
